import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { Key_getInstance1eahaybkym4fk as Key_getInstance } from './CustomScalarAdapters.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Token_NULL_getInstance1u01li7150917 as Token_NULL_getInstance } from './json/JsonReader.mjs';
import { MapJsonWriter4jz7ym6vbwk4 as MapJsonWriter } from './json/MapJsonWriter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Variables1mnjguxfc49u as Variables } from './Executable.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function falseVariables(_this__u8e3s4, customScalarAdapters) {
  var falseVariables = null;
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = variables(_this__u8e3s4, customScalarAdapters, true).n46_1.l3().p1();
  while (_iterator__ex2g4s.q1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var name = _destruct__k2r9zo.m3();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.n3();
    if (equals(value, false)) {
      var tmp0_elvis_lhs = falseVariables;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.collections.mutableSetOf' call
        // Inline function 'kotlin.also' call
        var this_0 = LinkedHashSet().s2();
        falseVariables = this_0;
        tmp = this_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      tmp.i2(name);
    }
  }
  var tmp1_elvis_lhs = falseVariables;
  return tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
}
function parseData(_this__u8e3s4, jsonReader, customScalarAdapters, falseVariables, deferredFragmentIds, errors) {
  customScalarAdapters = customScalarAdapters === VOID ? Key_getInstance().g45_1 : customScalarAdapters;
  falseVariables = falseVariables === VOID ? null : falseVariables;
  deferredFragmentIds = deferredFragmentIds === VOID ? null : deferredFragmentIds;
  errors = errors === VOID ? null : errors;
  var customScalarAdapters1 = customScalarAdapters.r45(falseVariables, deferredFragmentIds, errors);
  if (jsonReader.w3x().equals(Token_NULL_getInstance())) {
    jsonReader.v3x();
    return null;
  }
  return _this__u8e3s4.o46().s3x(jsonReader, customScalarAdapters1);
}
function variables(_this__u8e3s4, customScalarAdapters, withDefaultValues) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (MapJsonWriter())();
  this_0.f3y();
  _this__u8e3s4.p46(this_0, customScalarAdapters, withDefaultValues);
  this_0.g3y();
  var tmp = this_0.l3y();
  var valueMap = (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
  return new (Variables())(valueMap);
}
//region block: exports
export {
  falseVariables as falseVariables32gd1w4dsf9iv,
  parseData as parseData1xjh6qzzvft3n,
};
//endregion

//# sourceMappingURL=Executables.mjs.map
